/* 🤖 this file was generated by svg-to-ts */
export const siriusUserPlus: {
  name: 'user_plus';
  data: string;
} = {
  name: 'user_plus',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.125 4.5a4.875 4.875 0 1 0 0 9.75 4.875 4.875 0 0 0 0-9.75Zm3.393 10.273a6.375 6.375 0 1 0-6.786 0 11.249 11.249 0 0 0-5.225 3.495.75.75 0 0 0 1.149.964 9.75 9.75 0 0 1 14.938 0 .75.75 0 1 0 1.15-.964 11.25 11.25 0 0 0-5.226-3.495ZM21.75 10.5a.75.75 0 0 0-1.5 0V12h-1.5a.75.75 0 0 0 0 1.5h1.5V15a.75.75 0 0 0 1.5 0v-1.5h1.5a.75.75 0 0 0 0-1.5h-1.5v-1.5Z" fill="currentColor"/></svg>`
};
